<template>
  <div class="am-text-field">
    <am-input
      outlined
      :value="value"
      :valid="!errorText"
      :useNativeValidation="false"
      :textarea="textarea"
      :class="classes"
      v-bind="$attrs"
      v-on="$listeners"
      @input="$emit('model', $event.target.value)"
    >
      <am-floating-label v-if="label">{{ label }}</am-floating-label>
      <am-icon
        slot="leadingIcon"
        v-if="leadingIcon"
        :icon="leadingIcon"
        class="mdc-text-field__icon"
        tabindex="0"
        @click="$emit('click-leading-icon', $event)"
      />
      <am-typography
        class="am-text-field-text"
        slot="trailingIcon"
        v-if="trailingText && !persistentTrailingText && !trailingIconResult"
        variant="body1"
        color="medium"
        >{{ trailingText }}</am-typography
      >
      <am-icon
        slot="trailingIcon"
        v-if="trailingIconResult"
        :icon="trailingIconResult"
        class="mdc-text-field__icon error-icon"
        tabindex="-2"
        @click="$emit('click-trailing-icon', $event)"
      />
      <am-typography
        class="am-text-field-text am-persistent-trailing-text"
        slot="trailingIcon"
        v-if="trailingText && persistentTrailingText"
        >{{ trailingText }}</am-typography
      >
    </am-input>
    <am-text-field-helper-text
      v-if="helperText || errorText"
      :persistent="persistentHelperText"
      :validationMsg="!!errorText"
      >{{ errorText || helperText }}</am-text-field-helper-text
    >
  </div>
</template>

<script>
import AmIcon from "../Icon/Icon.vue";
import AmTypography from "../Typography/Typography.vue";
import AmInput from "./Input.vue";
import AmTextFieldHelperText from "./TextFieldHelperText.vue";
import AmFloatingLabel from "./FloatingLabel.vue";

export default {
  inheritAttrs: false,
  model: {
    prop: "value",
    event: "model"
  },
  components: {
    AmIcon,
    AmTypography,
    AmInput,
    AmFloatingLabel,
    AmTextFieldHelperText
  },
  props: {
    value: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    leadingIcon: {
      type: String,
      default: ""
    },
    trailingIcon: {
      type: String,
      default: ""
    },
    trailingText: {
      type: String,
      default: ""
    },
    upgraded: {
      type: Boolean,
      default: false
    },
    helperText: {
      type: String,
      default: ""
    },
    persistentHelperText: {
      type: Boolean,
      default: false
    },
    persistentTrailingText: {
      type: Boolean,
      default: false
    },
    errorText: {
      type: String
    },
    isValid: {
      type: Boolean,
      default: false
    },
    textarea: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes() {
      return {
        "mdc-text-field--valid": this.isValid && !this.errorText,
        "mdc-text-field--with-leading-icon": !!this.leadingIcon,
        "mdc-text-field--with-trailing-icon": this.trailingIconResult || this.trailingText
      };
    },
    trailingIconResult() {
      if (this.trailingIcon) {
        return this.trailingIcon;
      }

      if (this.errorText) {
        return "error_outline";
      }

      if (this.isValid) {
        return "check";
      }

      return null;
    }
  }
};
</script>
